import { msgTypes } from "constants/msgTypes";
import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import ApiUrl from "services/shared/ApiUrl";
import { UtilService } from "services/shared/UtilService";

const EventGallery = () => {
    const location = useLocation();
    const [galleryImageList, setGalleryImageList] = useState([]);
    const [allEventList, setAllEventList] = useState([]);
    const [event, setEvent] = useState(null);
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);

    useEffect(() => {
        if (location?.state?.event !== undefined) {
            setGalleryImageList(location?.state?.event?.gallery || []);
            setEvent(location?.state?.event);
            setAllEventList([]);
        } else {
            loadPreviousEventList();
            setGalleryImageList([]);
            setEvent(null);
        }
    }, [location.state]);

    const loadPreviousEventList = async () => {
        const res = await UtilService.getPreviousEventList();
        if (res.statusMsg === msgTypes.SUCCESS.msg) {
            setAllEventList(res.data || []);
        }
    };

    const openImageModal = (images, index) => {
        setGalleryImageList(images);
        setSelectedImageIndex(index);
    };

    const closeModal = () => {
        setSelectedImageIndex(null);
    };

    const showPrevImage = () => {
        setSelectedImageIndex((selectedImageIndex - 1 + galleryImageList.length) % galleryImageList.length);
    };

    const showNextImage = () => {
        setSelectedImageIndex((selectedImageIndex + 1) % galleryImageList.length);
    };

    return (
        <>
            <div className="page-wrapper wrapper-two">
                {/* Header Video */}
                <section className="page-header photo-gallery-banner member-section">
                    <video autoPlay muted loop playsInline style={{ width: "100%" }}>
                        <source src="https://www.oneworldnetwork.co/video/1wn-leadership-summit-2025.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </section>

                {/* All Events Gallery (only if no specific event is selected) */}
                {event === null && allEventList?.map((ourEvents, eIndex) => (
                    ourEvents?.gallery?.length > 0 && (
                        <div className="section-padding gallery-section" id="gallery" key={eIndex}>
                            <div className="container">
                                <div className="text-center event-gallery">
                                    <h2 className="title">{ourEvents?.eventName} Gallery</h2>
                                    <p>{UtilService.displayEventDate(ourEvents?.eventStartDate, ourEvents?.eventEndDate)}</p>
                                    <p>{ourEvents?.eventVenue}</p>
                                </div>
                                <div className="d-flex flex-wrap">
                                    {ourEvents?.gallery?.map((image, index) => (
                                        <div className="gallery sets" key={image}>
                                            <img
                                                src={ApiUrl.fileBaseUrl + image}
                                                alt=""
                                                onClick={() => openImageModal(ourEvents.gallery, index)}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )
                ))}

                {/* Specific Event Gallery */}
                {event && galleryImageList?.length > 0 && (
                    <div className="section-padding gallery-section" id="gallery">
                        <div className="container">
                            <div className="text-center">
                                <h2 className="title">{event?.eventName} Gallery</h2>
                                <p>{event?.eventStartDate ? UtilService.displayEventDate(event?.eventStartDate, event?.eventEndDate) : ""}</p>
                                <p>{event?.eventVenue}</p>
                            </div>
                            <div className="d-flex flex-wrap">
                                {galleryImageList.map((image, index) => (
                                    <div className="gallery sets" key={image}>
                                        <img
                                            src={ApiUrl.fileBaseUrl + image}
                                            alt=""
                                            onClick={() => openImageModal(galleryImageList, index)}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* No Gallery Fallback */}
                {!event && allEventList.every(event => !event.gallery || event.gallery.length === 0) && (
                    <div className="container">
                        <div className="no-gallery">
                            <img src="/images/resources/no-photo-gallery.png" alt="No Gallery Available" />
                        </div>
                    </div>
                )}
            </div>

            {/* Modal */}
            {selectedImageIndex !== null && (
                <div className="image-modal">
                    <div className="modal-content">
                        <button className="close-button" onClick={closeModal}>×</button>
                        <button className="prev-button" onClick={showPrevImage}>‹</button>
                        <img
                            src={ApiUrl.fileBaseUrl + galleryImageList[selectedImageIndex]}
                            alt="Zoomed"
                        />
                        <button className="next-button" onClick={showNextImage}>›</button>
                    </div>
                </div>
            )}

            {/* Modal CSS */}
            <style>{`
                .image-modal {
                    position: fixed;
                    top: 0; left: 0;
                    width: 100%; height: 100%;
                    background: rgba(0,0,0,0.8);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1000;
                }
                .modal-content {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .modal-content img {
                    max-width: 90vw;
                    max-height: 90vh;
                }
                .close-button,
                .prev-button,
                .next-button {
                    position: absolute;
                    background: rgba(243, 123, 5, 0.8);
                    border: none;
                    font-size: 2rem;
                    cursor: pointer;
                    padding: 5px 10px;
                    z-index: 1001;
                    color: #fff;
                }
                .close-button {
                    top: 10px;
                    right: 10px;
                }
                .prev-button {
                    left: 10px;
                }
                .next-button {
                    right: 10px;
                }
            `}</style>
        </>
    );
};

export default EventGallery;
